import * as environment from "environment";
import { AuthConfig } from "@energylab/shared-components/constants/config/authConfig";

export const auth: AuthConfig = {
    facebookRedirect: environment.auth.facebook,
    googleRedirect: environment.auth.google,
    anonymousToken: environment.anonymousToken
};
